import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {TopicDTO, UserDTO} from '../../../services/api/api';
import {UtilService} from '../../../services/util.service';

@Component({
  selector: 'sb-comp-discussion-topic',
  templateUrl: './sb-discussion-subtitle.component.html',
  styleUrls: ['./sb-discussion-subtitle.component.scss'],
  standalone: false,
})
export class SbDiscussionSubtitleComponent implements OnInit {
  @Input() inChat: boolean;
  @Input() post: TopicDTO;
  @Input() classes: string;

  @Output() goBack: EventEmitter<boolean>;

  constructor(public util: UtilService) {
    this.inChat = false;
    this.goBack = new EventEmitter<boolean>();
  }

  ngOnInit(): void {}

  close() {
    this.goBack.emit(true);
  }
}
